module.exports = __webpack_public_path__ + "img/play_rectangle_fill.6080d92e.svg";